'use client';

import { ComponentType, ComponentProps } from 'react';
import styled from 'styled-components';
import { motion, type MotionProps } from 'framer-motion';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

export const ToggleBase = styled.div`
  color: var(--navbar-toggle-color, #282828);

  z-index: 1;
`;

type CurtainProps = ComponentProps<'div'> & MotionProps;

export const Curtain = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;

  pointer-events: none;

  @media (max-width: 768px) {
    bottom: 0;
  }
` as ComponentType<CurtainProps>;

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  z-index: 1;

  width: 360px;
  box-sizing: border-box;
  pointer-events: all;
  overflow: hidden;
  color: var(--navbar-toggle-color, #fff);
  background: var(--navbar-toggle-background, #700);

  border-radius: 0 0 24px 24px;
  border-bottom: 3px solid var(--navbar-toggle-background);

  @media (max-width: 768px) {
    transform: none !important;
    width: 100%;
    border-radius: 0;
  }
`;

export const OverlayScrollbars = styled(OverlayScrollbarsComponent)`
  display: flex;
  flex: 1;

  padding: 24px;

  box-sizing: content-box;
  max-height: 630px;

  & .os-scrollbar-vertical {
    padding: 24px 0;
    right: 8px;
    width: 6px;
  }

  & .os-scrollbar-handle,
  & .os-scrollbar-handle:hover {
    background: var(--navbar-toggle-accent-background, #fff0f0) !important;
  }

  @media (max-width: 768px) {
    max-height: 100%;
  }
`;
